import isInWebView from './isInWebView';

const guards = {
  isInWebView,
};

export default guards;
